import { render, staticRenderFns } from "./Notifications.vue?vue&type=template&id=43a3e4e8&scoped=true"
import script from "./Notifications.vue?vue&type=script&lang=js"
export * from "./Notifications.vue?vue&type=script&lang=js"
import style0 from "./Notifications.vue?vue&type=style&index=0&id=43a3e4e8&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43a3e4e8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('43a3e4e8')) {
      api.createRecord('43a3e4e8', component.options)
    } else {
      api.reload('43a3e4e8', component.options)
    }
    module.hot.accept("./Notifications.vue?vue&type=template&id=43a3e4e8&scoped=true", function () {
      api.rerender('43a3e4e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Notifications.vue"
export default component.exports